import { UseToastOptions } from '@chakra-ui/react'

export const chakraToastConfig: UseToastOptions = {
  position: 'top-right',
  duration: 5000,
  isClosable: true
}
